import React from 'react';
import { Card, Avatar, Typography, Space, Tag, Button, Row, Col, Statistic } from 'antd';
import {
  MailOutlined,
  PhoneOutlined,
  BankOutlined,
  UserOutlined,
  MedicineBoxOutlined,
  EyeOutlined,
} from '@ant-design/icons';
import { useHistory } from 'react-router-dom';
import PartnerStatusBadge from '../shared/PartnerStatusBadge';
import { getInitials } from '../../utils/helpers';
import './PartnerCard.css';

const { Text, Paragraph } = Typography;

const PartnerCard = ({ partner, onClick }) => {
  const history = useHistory();

  const handleClick = () => {
    if (onClick) {
      onClick(partner);
    } else {
      history.push(`/b2b/partners/${partner.id}`);
    }
  };

  return (
    <Card
      hoverable
      className="partner-card"
      onClick={handleClick}
      cover={
        <div className="partner-card-cover">
          <Avatar
            size={80}
            src={partner.logo}
            icon={!partner.logo && <UserOutlined />}
            style={{ backgroundColor: partner.logo ? 'transparent' : '#1890ff' }}
          >
            {!partner.logo && getInitials(partner.name)}
          </Avatar>
        </div>
      }
      actions={[
        <Button
          key="view"
          type="link"
          icon={<EyeOutlined />}
          onClick={(e) => {
            e.stopPropagation();
            history.push(`/b2b/partners/${partner.id}`);
          }}
        >
          View Details
        </Button>,
      ]}
    >
      <Card.Meta
        title={
          <Space direction="vertical" size="small" style={{ width: '100%' }}>
            <Text strong style={{ fontSize: 16 }}>
              {partner.name}
            </Text>
            <PartnerStatusBadge status={partner.status} />
          </Space>
        }
        description={
          <Space direction="vertical" size="small" style={{ width: '100%', marginTop: 12 }}>
            <Space>
              <MailOutlined style={{ color: '#8c8c8c' }} />
              <Text ellipsis style={{ maxWidth: 200 }}>
                {partner.email}
              </Text>
            </Space>
            <Space>
              <PhoneOutlined style={{ color: '#8c8c8c' }} />
              <Text>{partner.phone}</Text>
            </Space>
          </Space>
        }
      />

      {partner.description && (
        <Paragraph
          ellipsis={{ rows: 2, expandable: false }}
          style={{ marginTop: 16, color: '#8c8c8c' }}
        >
          {partner.description}
        </Paragraph>
      )}

      <Row gutter={16} style={{ marginTop: 16 }}>
        <Col span={12}>
          <Statistic
            title="Clinics"
            value={partner.clinics_count || 0}
            prefix={<BankOutlined />}
            valueStyle={{ fontSize: 20 }}
          />
        </Col>
        <Col span={12}>
          <Statistic
            title="Doctors"
            value={partner.doctors_count || 0}
            prefix={<MedicineBoxOutlined />}
            valueStyle={{ fontSize: 20 }}
          />
        </Col>
      </Row>

      {partner.has_maib_credentials && (
        <Tag
          color="blue"
          icon={<BankOutlined />}
          style={{ marginTop: 16 }}
        >
          MAIB Configured
        </Tag>
      )}
    </Card>
  );
};

export default PartnerCard;
